import React from 'react';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/images/building-hero.jpg" 
          alt="Changuna Aangan Building" 
          className="w-full h-full object-cover"
          loading="lazy"
        />
        {/* Dark gradient overlay at bottom for text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
      </div>

      {/* Title & Subtitle - Center Bottom */}
      <div className="absolute bottom-24 left-1/2 transform -translate-x-1/2 text-center z-10 px-4">
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-3 drop-shadow-lg">
          चांगुणा आंगण
        </h1>
        <p className="text-lg md:text-xl text-white/90 font-medium drop-shadow-md">
          RERA Approved Residences | Diva Junction | Starting from 320 Sq. Ft Rera Carpet
        </p>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <div className="w-6 h-10 border-2 border-white/70 rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white/70 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
